
/**
 * Checks for the existence of a permission for a given application in the user permissions object
 * @param  {String}  app Name of the application the target permission belongs to
 * @param  {String}  permission Name of the permission to check
 * @param  {object}  userPermissions Object containing the user permissions
 * @return {Boolean} returns true if the user has the specified permission, otherwise false
 */
export default function ( app, permission, userPermissions = {} ) {
    return ( userPermissions[ app ] || [] ).includes( permission );
}